export default "assets/facebook-f939afc7.svg";